var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M2.822 17.82c-.026.064-.047.122-.065.175 7.083-.052 11.193-.05 12.387.006l-.095 2c-1.176-.057-5.51-.057-12.946 0l-.21.002-.19-.083c-1.992-.853-1.13-3.003 1.602-6.532l.128-.165.182-.1c7.357-4.03 16.087-1.265 17.455 4.652l-1.948.45C18.092 13.765 11 11.48 4.76 14.78 3.75 16.096 3.1 17.12 2.82 17.82zM11 10c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-2c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.42ce56d6d1ed5d49cde168209f2a6030.svg";
export { ForwardRef as ReactComponent };